module.exports = __webpack_public_path__ + "img/M09.bad3bb30.png";